import { IFilter } from 'commerce/factFinder/types';

export const filterQueryParameters = (filters: IFilter[]) => {
  return filters.reduce<Record<string, IFilter['value']>>((acc, item) => {
    if (!item.type || !item.value) {
      return acc;
    }

    const currentFilter = acc[item?.type || ''] || [];
    const value = Array.isArray(currentFilter)
      ? [...currentFilter, item.value]
      : [item.value];

    acc[item.type] = value.flat();

    return acc;
  }, {});
};
